import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select/select.component';
import { StpMaterialModule } from '../material/material.module';
import { StpFormsModule } from '../../stp-app/forms/forms.module';

@NgModule({
  imports: [
    CommonModule,
    StpMaterialModule,
    StpFormsModule
  ],
  declarations: [
    SelectComponent
  ],
  exports: [
    SelectComponent
  ]
})
export class StpSelectModule { }
